<template>
  <!-- Sync-in-progress window after a real Lens connect. -->
  <div>
    <div class="flex items-center gap-2 px-3.5 py-2 border-b border-border-normal">
      <div class="w-4 h-4 rounded bg-neutral-900 flex-shrink-0" />
      <BaseText
        type="label"
        size="xs"
        class="text-text-muted"
      >
        Lens · Syncing
      </BaseText>
      <span class="ml-auto scene-pill">24-48hrs</span>
    </div>
    <div class="px-3.5 py-3 flex flex-col gap-2">
      <div
        v-for="(row, index) in rows"
        :key="row.label"
        class="scene-row flex items-center gap-2"
        :style="{ animationDelay: `${160 + index * 90}ms` }"
      >
        <span
          class="scene-dot"
          :class="row.done ? 'scene-dot--done' : 'scene-dot--wait'"
        />
        <BaseText
          type="label"
          size="xs"
          :class="row.done ? 'text-text-loud' : 'text-text-subdued'"
        >
          {{ row.label }}
        </BaseText>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LensConnectedScene',
  data () {
    return {
      rows: [
        { label: 'Ad account authenticated', done: true },
        { label: 'Creatives importing', done: false },
        { label: 'Reports ready', done: false }
      ]
    }
  }
}
</script>

<style scoped>
.scene-pill {
  font-size: 10px;
  font-weight: 600;
  line-height: 14px;
  color: theme('colors.neutral.600');
  background-color: theme('colors.neutral.25');
  border-radius: 9999px;
  padding: 2px 8px;
}
.scene-row {
  animation: scene-row-in 320ms ease-out both;
}
.scene-dot {
  width: 8px;
  height: 8px;
  border-radius: 9999px;
  flex-shrink: 0;
}
.scene-dot--done {
  background-color: theme('colors.primary.green-100');
}
.scene-dot--wait {
  background-color: theme('colors.neutral.100');
}
@keyframes scene-row-in {
  from {
    opacity: 0;
    transform: translateY(3px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@media (prefers-reduced-motion: reduce) {
  .scene-row {
    animation: none;
  }
}
</style>
